<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-08-28 18:15:15
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-10-19 14:57:00
 * @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/scanCodePayManagement/common/tipMessage.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="tip-wrapper">
    <div class="tip-left"><i class="el-icon-warning-outline"></i></div>
    <div class="tip-right">
      <div v-for="(item, index) in tipData" :key="index">
        <div>
          {{ item.title }}
          <span
            v-if="item.flag"
            class="blue-c"
            @click="downFile(item.downLoadTitle, item.payWay)"
            >{{ item.downLoadTitle }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TipMessage',
  props: {
    tipData: Array,
  },
  methods: {
    downFile(downLoadTitle, payWay) {
      const a = document.createElement('a'); // 创建一个<a></a>标签
      // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
      a.href =
        payWay === 10
          ? '/static/微信实名验证操作指引.pdf'
          : '/static/支付宝实名认证操作指引.pdf';
      a.download = downLoadTitle; // 设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
      a.style.display = 'none'; // 障眼法藏起来a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove(); // 一次性的，用完就删除a标签
    },
  },
};
</script>

<style scoped lang="scss">
.tip-wrapper {
  width: 100%;
  padding: 15px 10px;
  background-color: #e8efff;
  font-size: 14px;
  display: flex;
  margin: 20px 0;
  background-color: #e8efff;
  .tip-left {
    color: #2587ff;
    width: 20px;
    margin-top: 3px;
  }
  .tip-right {
    color: #666;
    .blue-c {
      color: #2f80ed;
      cursor: pointer;
    }
  }
}
</style>
